const factory = Model => {
  class LedgerCategoryOrder extends Model {
    $url() {
      return `${this.$resource}.json/order/client/${this.clientId}/category/${this.$storeId()}`;
    }

    $orderByAlpha() {
      return this.$apiCall({
        method: 'PUT',
        url: `${this.$url()}/order_by_alpha`,
      });
    }

    $orderManual() {
      return this.$apiCall({
        method: 'PUT',
        url: `${this.$url()}/order_manual`,
      });
    }

    $fetch() {}
  }

  LedgerCategoryOrder.prototype.$resource = 'ledgeraccountcategory';
  LedgerCategoryOrder.prototype.$idName = 'categoryId';

  return LedgerCategoryOrder;
};

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.model.ledgerCategoryOrder', moduleDeps)
  .factory('LedgerCategoryOrder', factory);
